import {TweenLite} from 'gsap';
const Snap = require('imports-loader?this=>window,fix=>module.exports=0!snapsvg/dist/snap.svg.js');
const DataUtils = require('../../../viscomjs/utils/data');

const WM = require('../BOSSWatermarkSingleton');
const Constants = require('../Constants');
const SizesUtils = require('../../../viscomjs/utils/SizesUtils');

const win = window;
let n = 0;

const _init = function () {
    this._shift = 0;

    if (this.el.dataset && this.el.dataset.wmImage && this.el.dataset.wmImage !== 'false') {
        this.hasImage = true;
        this.svg = this.el.querySelector('svg');
        this.image = this.el.querySelector('image');
        this.image.setAttribute('xlink:href', this.el.dataset.wmImage);
        this.pattern = this.el.querySelector('pattern');
        this.pattern.id = 'pattern-' + n;
        const fill = this.el.querySelector('.wm__fill');
        n++;
        if (fill)
            fill.setAttribute('fill', `url(#${this.pattern.id})`);
    } else
        this.el.classList.add('wm--no-image');

    if (this.hasImage) {
        const tmp = this.el.querySelector('.wm__back');
        if (tmp && tmp.parentNode) tmp.parentNode.removeChild(tmp);
    }

    this.paths = [...this.g.querySelectorAll('path')];

    this.paths.forEach(p => {
        let path = p.getAttribute('d');
        path = Snap.path.toRelative(path);
        if (path.length < 1) return;

        DataUtils.setData(p, 'x0', path[0][1]);
        DataUtils.setData(p, 'path', path);

        p.setAttribute('d', path.toString());

    });

    let i;
    let cln;
    let paths;
    const delta = Constants.BOSSWatermarkRefHeight * Constants.BOSSWatermarkPeriodRatio;
    for (i = 0; i < 2; i++) {
        cln = this.g.cloneNode(true);
        this.g.parentNode.appendChild(cln);

        paths = [...cln.querySelectorAll('path')];

        paths.forEach(p => {
            let path = p.getAttribute('d');
            path = Snap.path.toRelative(path);
            if (path.length < 1) return;

            DataUtils.setData(p, 'x0', path[0][1] + delta * (i + 1));
            DataUtils.setData(p, 'path', path);

            p.setAttribute('d', path.toString());

        });
        this.paths = this.paths.concat(paths);
    }

    win.addEventListener('resize', this._handleResize);
    this._handleResize();
}


const _start = function () {
    if (this._started) return;
    WM.on('update', this._update);
    this._started = true;
    return this;
}


const _stop = function () {
    if (!this._started) return;
    WM.off('update', this._update);
    this._started = false;
    return this;
}

const _update = function (progress, dx) {

    const x1 = (WM.getWrapTotalShift() + this._dX0 + this._shift) / this._scale;

    this.paths.forEach(p => {
        const path = DataUtils.getData(p, 'path');
        const x0 = DataUtils.getData(p, 'x0');
        if (path.length < 1) return;

        path[0][1] = x0 - dx - x1;

        p.setAttribute('d', path.toString());

    })
};

const _handleResize = function () {
    const h = SizesUtils.winOffsetHeight();
    const sH = h / Constants.BOSSWatermarkRefHeight;
    this._scale = sH;

    const r1 = this.el.getBoundingClientRect();
    this._dX0 = r1.left - WM.getWrapTotalShift();
    this.svg.setAttribute('width', Math.ceil(Constants.BOSSWatermarkRatio * h) + 'px');

    if (!this.hasImage) return;

    const w0 = SizesUtils.winOffsetWidth();
    const w = w0 / sH;

    const s = Constants.BOSSWatermarkScale * Math.max(1, w / Constants.BOSSWatermarkRefWidth);
    const w1 = s * Constants.BOSSWatermarkRefWidth;
    const dw = (w1 - w) / 2;

    TweenLite.set(this.image, {scale: s, x: Math.min(0, -dw)});
    this.pattern.setAttribute('width', Math.ceil(w));
    this.pattern.setAttribute('viewBox', `0 0 ${Math.ceil(w)} ${Constants.BOSSWatermarkRefHeight}`);

};

const _setLocalShift = function (value) {
    this._shift = value;
}


module.exports = el => {
    const wm = {
        el: el,
        g: el.querySelector('.wm__g'),
        svg: el.querySelector('svg')
    };

    wm.init = _init.bind(wm);
    wm.start = _start.bind(wm);
    wm.stop = _stop.bind(wm);
    wm.setLocalShift = _setLocalShift.bind(wm);
    wm._update = _update.bind(wm);
    wm._handleResize = _handleResize.bind(wm);

    return wm;
};


// WEBPACK FOOTER //
// ./js/viscom/boss/soccers/components/SVGWatermark.js